import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNotification = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M5.36088 9.213L5.35709 9.426V15.7351C5.35709 15.8846 5.31242 16.0306 5.22882 16.1545L3.88729 18.143H18.11L16.7685 16.1545C16.6849 16.0306 16.6402 15.8846 16.6402 15.7351V9.4193C16.6402 6.35381 14.1229 3.85352 10.9987 3.85352C7.94488 3.85352 5.47031 6.24293 5.36088 9.213ZM3.8616 9.166C3.99693 5.37276 7.14819 2.35352 10.9987 2.35352C14.9344 2.35352 18.1402 5.50856 18.1402 9.4193V15.5057L20.1425 18.4735C20.2976 18.7034 20.3132 19.0001 20.183 19.245C20.0528 19.4899 19.7981 19.643 19.5207 19.643H2.47656C2.19922 19.643 1.94452 19.4899 1.81433 19.245C1.68414 19.0001 1.69972 18.7034 1.85483 18.4735L3.85709 15.5057V9.4059L3.8616 9.166Z",
			fill: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M11 0.25C11.4142 0.25 11.75 0.58579 11.75 1V3.10526C11.75 3.51947 11.4142 3.85526 11 3.85526C10.5858 3.85526 10.25 3.51947 10.25 3.10526V1C10.25 0.58579 10.5858 0.25 11 0.25Z",
			fill: "inherit"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M8.86719 18.1445C9.2814 18.1445 9.6172 18.4803 9.6172 18.8945C9.6172 19.6346 10.2268 20.2498 10.9977 20.2498C11.7686 20.2498 12.3782 19.6346 12.3782 18.8945C12.3782 18.4803 12.714 18.1445 13.1282 18.1445C13.5424 18.1445 13.8782 18.4803 13.8782 18.8945C13.8782 20.4799 12.5801 21.7498 10.9977 21.7498C9.4153 21.7498 8.11719 20.4799 8.11719 18.8945C8.11719 18.4803 8.45297 18.1445 8.86719 18.1445Z",
			fill: "inherit"
		})
	]
});
export default SvgNotification;
